import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import { useFetchApi } from "../../hooks/useFetchApi";
import TextField from "../../components/TextField";
import { captialCase } from "../../helper";

const BulkUploadModal: React.FC<{
  name?: string;
  status: boolean;
  onClose: any;
  onSuccess?: any;
  data?: any;
}> = ({ name, status, onClose, onSuccess, data = {} }): React.ReactElement => {
  const isDynamicMetrics = name
    ? ["gross-profits", "net-profits", "revenues", "pe-valuations", "stocks"].includes(
        name
      )
      ? false
      : true
    : false;
  const [d, setD] = useState<any>({});
  const { execute } = useFetchApi(
    `/api/bulk-upload/${isDynamicMetrics ? "metrics" : name ? name : "stocks"}`,
    {},
    "POST",
    onSuccess
  );

  const handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.files;
    if (value.length) {
      setD({ ...d, [id]: value[0] });
    }
  };

  const handleOnSubmit = (e: any) => {
    const formData = new FormData();
    formData.append("file", d.file);
    formData.append("marketId", d.selectedMarket);
    if (name) {
      formData.append("name", name.replace(/-/g, "_"));
    }
    execute(formData, { "Content-Type": "multipart/form-data" });
    const _e = { ...e, target: { ...e.target, id: name } };
    onClose(_e);
  };

  const handleClose = (e: any) => {
    const _e = { ...e, target: { ...e.target, id: name } };
    onClose(_e);
  };

  const beautify = (name: string) => {
    return name
      .split("-")
      .map((n: string) => n[0].toUpperCase() + n.slice(1))
      .join(" ");
  };

  useEffect(() => {
    if (data && Object.keys(data).length) {
      setD(data);
    }

    return () => {
      setD({});
    };
  }, [data]);

  return (
    <Modal
      heading={`Bulk Upload ${name ? beautify(name) : ""}`}
      status={status}
      onClose={handleClose}
      onSubmit={handleOnSubmit}
    >
      <TextField
        className="md:w-full h-auto border"
        id="file"
        type="file"
        onChange={handleChange}
      />
    </Modal>
  );
};

export default BulkUploadModal;
